export const PDF_EXPORTING_MODAL_QUESTION_UID = 'pdf_exporting'
export const LOW_RISK_INDICATORS_PDF_EXPORTING_MODAL_UID = 'low_risk_indicators_pdf_exporting'
export const HIGH_RISK_INDICATORS_PDF_EXPORTING_MODAL_UID = 'high_risk_indicators_pdf_exporting'
export const LOW_RISK_INDICATORS_AD_HOC_PDF_EXPORTING_MODAL_UID = 'low_risk_indicators_ad_hoc_pdf_exporting'
export const HIGH_RISK_INDICATORS_AD_HOC_PDF_EXPORTING_MODAL_UID = 'high_risk_indicators_ad_hoc_pdf_exporting'
export const SHARE_BUSINESS_CASE_MODAL_UID = 'share_business_case'